import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ControlCreditoService } from '../../../control-credito.service';
import { saveAs } from 'file-saver';
import { UnidadMedida } from '@shared/enums/unidadMedida';
import { TipoVuelo } from '@shared/enums/tipoVuelo';
import { ErrorModel } from "@shared/models/ErrorModel";
import { MessageService } from "@shell/message.service";

@Component({
  selector: 'app-modal-reporte-aerovales',
  templateUrl: './modal-reporte-aerovales.component.html',
  styleUrl: './modal-reporte-aerovales.component.scss'
})
export class ModalReporteAerovalesComponent {
  @Input() aerovales;
  pendiente = { codigo: "Pendiente", descripcion: "Pendiente", seleccionado: false };
  finalizado = { codigo: "Finalizado", descripcion: "Finalizado", seleccionado: false };
  finalizadoSinFirma = { codigo: "FinalizadoSinFirma", descripcion: "Finalizado sin firma", seleccionado: false };
  unidadMedida = UnidadMedida;
  tipoVuelo = TipoVuelo;
  areas = [
    this.pendiente,
    this.finalizado,
    this.finalizadoSinFirma
  ];
  errorEnExportacion: boolean = false;

  constructor(private controlCreditoService: ControlCreditoService, public activeModal: NgbActiveModal, private messageService: MessageService) { }

  obtenerDescripcionMoneda(tipoMoneda: string): string {
    return tipoMoneda === 'USD' ? 'DOL' : 'PES';
  }

  descargarExcel() {
    const aerovalesReporte = this.aerovales.map(aerovale => {
      return {
        aeroplanta: aerovale.aeroplanta,
        aerovale: aerovale.numeroAerovale ? `${aerovale.prefijo}-${aerovale.numeroAerovale}` : "",
        cotizacion: aerovale.cotizacion,
        cantidad: aerovale.volumenNaturales,
        impuestos: aerovale.impuestos,
        matricula: aerovale.matricula,
        monto: aerovale.monto,
        productoCodigo: aerovale.codigoProducto,
        productoNombre: aerovale.nombreProducto,
        rancho: aerovale.rancho,
        tipoOperacion: TipoVuelo[aerovale.tipoVuelo],
        tipoMoneda: aerovale.tipoMoneda == 'ARS' ? 'PES' : 'DOL',
        unidadDeMedida: UnidadMedida[aerovale.unidadMedida]
      };
    });
    this.errorEnExportacion = false;
    this.controlCreditoService.descargarExcelActualizacionAerovales(aerovalesReporte)
      .subscribe((res: Blob) => {
        const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' });
        saveAs(blob, "ListadoDeAerovales");
      }, (error:ErrorModel) => {
        this.messageService.showErrorMessage("Error al exportar excel: " + error.description);
        this.errorEnExportacion = true;
        console.log("error")
      });
  }
}
